import {
  Profession,
  Purpose,
  NumberOfDependents,
  RentOrMortgage,
} from 'apollo/queries/autogenerate/schemas';

export enum VERIFY_OPTION {
  NOW = 0,
  LATER = 1,
}
export enum ONBOARDING_SLIDE {
  VERIFY_STAGE = 0,
  INFO_STAGE = 1,
  SELECT_STAGE = 2,
  QR_CODE_STAGE = 3,
}

export enum SELECTED_METHOD {
  MOBILE_APP = 0,
  MOBILE_WEB = 1,
  DESKTOP = 2,
}

export enum DOCUMENT_TYPE {
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  MY_NUMBER = 'MY_NUMBER',
}

export enum EKYC_SCREEN {
  PICK_DOCUMENT = 0,
  LIQUID_TERMS = 1,
}

export enum EKYC_FORM {
  PERSONAL_INFO = 0,
  ADDRESS = 1,
  PAC = 2,
  PEP = 3,
  CONFIRMATION = 4,
}

export const PROFESSIONS = [
  '会社員・団体職員',
  '会社役員・団体役員',
  '公務員',
  '自営業',
  '契約・派遣社員',
  'パート・アルバイト',
  '主婦・主夫・家事手伝い',
  '年金受給者',
  '学生',
  '無職',
];

export const PURPOSES = [
  '生計費決済（普段のお買いもの）',
  '事業費決済（事業の費用）',
  '生活費決済と事業費決済',
];

export const DEPENDENTS = ['1名', '2名', '3名', '4名以上'];

export const HAVE_OR_NOT = ['なし', 'あり'];

export const PEPS_STATUS = ['該当しない', '該当する'];

export const FIREBASE_MOBILE_APP_URL = 'https://d9r4z.app.goo.gl/ds6z';

export type PersonalInfoProps = {
  lastName: string;
  firstName: string;
  lastNameKana: string;
  firstNameKana: string;
  dateOfBirth: string;
};

export const PERSONAL_INFO_FORM_FIELD_NAMES: Array<keyof PersonalInfoProps> = [
  'lastName',
  'firstName',
  'lastNameKana',
  'firstNameKana',
  'dateOfBirth',
];

export const PERSONAL_INFO_FORM_FIELD_LABELS = [
  '姓',
  '名',
  'セイ（カタカナ）',
  'メイ（カタカナ）',
  '生年月日',
];

export const PERSONAL_INFO_FORM_FIELD_PLACHOLDERS = [
  '姓',
  '名',
  'セイ（カタカナ）',
  'メイ（カタカナ）',
  '',
];

export type AddressProps = {
  city: string;
  state: string;
  zip: string;
  /**
   * apartment
   */
  line1: string;
  /**
   * street/block
   */
  line2: string;
};

export const ADDRESS_FORM_FIELD_NAMES: Array<keyof AddressProps> = [
  'zip',
  'state',
  'city',
  'line2',
  'line1',
];

export const ADDRESS_FORM_FIELD_LABELS = [
  '郵便番号',
  '都道府県',
  '市区町村',
  '丁目・番地',
  '建物名・部屋番号（任意）',
];

export const ADDRESS_FORM_FIELD_PLACEHOLDERS = [
  '1080025',
  '選択',
  '港区六本木',
  '１−２−３',
  'マンション名１０１号',
];

export type PACProps = {
  profession: string;
  purpose: string;
  salary: string;
  numberOfDependents: string;
  rentOrMortgage: string;
};

export const PAC_FORM_FIELD_NAMES: Array<keyof PACProps> = [
  'profession',
  'purpose',
  'salary',
  'numberOfDependents',
  'rentOrMortgage',
];

export const PAC_FORM_FIELD_LABELS = [
  'ご職業',
  'ご利用目的',
  '年収（万単位）',
  ' 同一生計人数（本人・別居含む）',
  '家賃・住宅ローンの支払い（配偶者含む）',
];

export const PAC_FORM_FIELD_PLACEHOLDERS = [
  '選択してください',
  '選択してください',
  '600',
  '選択してください',
  '選択してください',
];

export type PEPProps = {
  pepStatus: string;
};

export const PEP_FORM_FIELD_NAMES: Array<keyof PEPProps> = ['pepStatus'];

export const PEP_FORM_FIELD_LABELS = ['外国PEPs'];

export const PEP_FORM_FIELD_PLACEHOLDERS = ['選択してください'];

export const PREFECTURES = [
  '選択してください',
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
];

export const DEPENDENTS_FORM_KEYS: Array<keyof typeof NumberOfDependents> = [
  'ZERO',
  'ONE',
  'TWO',
  'THREE_OR_MORE',
];

export const HAVE_OR_NOT_FORM_KEYS: Array<keyof typeof RentOrMortgage> = [
  'NO',
  'YES',
];

export const PROFESSION_FORM_KEYS: Array<keyof typeof Profession> = [
  'EMPLOYEE',
  'EXECUTIVE',
  'CIVIL_OFFICER',
  'SELF_EMPLOYED',
  'TEMPORARY',
  'PART_TIME',
  'HOUSEWIFE',
  'PENSIONER',
  'STUDENT',
  'UNEMPLOYED',
];

export const PURPOSE_FORM_KEYS: Array<keyof typeof Purpose> = [
  'SHOPPING',
  'BUSINESS',
  'PAYMENT',
];

export const APPLICANT_ID = 'applicantId';

export const EKYC_APPLICATION_STATUS = 'ekycApplicationStatus';

export enum EKYC_APPLICATION_STAGE {
  PRE_APPLICATION = 'pre-application',
  POST_APPLICATION = 'post-application',
}

export const EKYC_BRODCAST_CHANNEL = 'ekyc-brodcast-channel';

export enum EKYC_BRODCAST_MESSAGE {
  NAVIGATE_TO_ACCOUNT = 'navigate-to-account',
}
